import { IconButton } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { RightSidebarIcon } from '@blocksuite/icons/rc';

import { AFFINE_RIGHT_SIDEBAR_SHORTCUT } from '../../../../commands/affine-keybindings';
import * as styles from './sidebar-header.css';

export type HeaderProps = {
  onToggle?: () => void;
  children?: React.ReactNode;
};

function Container({
  children,
  style,
  className,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div data-testid="header" style={style} className={className}>
      {children}
    </div>
  );
}

const ToggleButton = ({ onToggle }: { onToggle?: () => void }) => {
  const t = useI18n();
  const tooltip = t['com.streamlain.cmdk.affine.right-sidebar.collapse']();

  return (
    <IconButton
      size="24"
      onClick={onToggle}
      data-testid="right-sidebar-close"
      aria-label={tooltip}
      tooltip={tooltip}
      tooltipShortcut={AFFINE_RIGHT_SIDEBAR_SHORTCUT}
      tooltipOptions={{ side: 'bottom' }}
    >
      <RightSidebarIcon />
    </IconButton>
  );
};

export const Header = ({ children, onToggle }: HeaderProps) => {
  return (
    <Container className={styles.header}>
      {children}
      {!BUILD_CONFIG.isElectron && (
        <>
          <div className={styles.spacer} />
          <ToggleButton onToggle={onToggle} />
        </>
      )}
    </Container>
  );
};
